import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const ShareIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9426 7.44186L14.6778 6.42969L16.4129 7.44186V9.46621L14.6778 10.4784L13.5357 9.81219L9.47031 12.0482V13.0138L13.4861 15.2225L14.6778 14.5273L16.4129 15.5395V17.5639L14.6778 18.576L12.9426 17.5639V16.0649L8.90728 13.8454L7.73516 14.5292L6 13.517V11.4926L7.73516 10.4805L8.95347 11.1911L12.9426 8.99712V7.44186Z"
      fill="currentColor"
    />
  </svg>,
  'share'
);
